import { useScript } from "@sphtech/web2-core/hooks";
import { Helmet } from "react-helmet-async";

export default function ArticleEmbedFlourish({ url }: { url: string }) {
  const pathname = new URL(url).pathname;

  // Load Flourish embed script after rendering
  useScript({
    src: "https://public.flourish.studio/resources/embed.js",
    id: "flourish-embed-script",
  });

  if (!pathname) return null;

  // Remove slash beginning and end
  const path = pathname.replace(/^\/|\/$/g, "");

  return (
    <>
      <Helmet>
        <style id="flourish-embed-style">
          {`
            .flourish-embed .flourish-credit {
              display: none !important;
            }
          `}
        </style>
      </Helmet>

      <div
        style={{ width: "100%" }}
        className="flourish-embed w-full"
        data-src={path}
      />
    </>
  );
}
